module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-center-main",
    class: {
      'collapsed': _vm.sidebarCollapsed, 'big-mode': !_vm.sidebarCollapsed, 'small-mode': _vm.sidebarCollapsed
    }
  }, [_c('top-bar', {
    attrs: {
      "activeNavIdx": _vm.activeNavIdx
    },
    on: {
      "update:activeNavIdx": function($event) {
        _vm.activeNavIdx = $event
      },
      "update:active-nav-idx": function($event) {
        _vm.activeNavIdx = $event
      },
      "toggleSideBar": _vm.toggleSideBar
    }
  }), _vm._v(" "), _c('side-bar', {
    ref: "sideBar",
    attrs: {
      "activeNavIdx": _vm.activeNavIdx,
      "text": "MoName",
      "href": "MoUrl",
      "isLeaf": "IsLeaf",
      "logo": "MoLogo",
      "groupKey": "MoType"
    },
    on: {
      "update:activeNavIdx": function($event) {
        _vm.activeNavIdx = $event
      },
      "update:active-nav-idx": function($event) {
        _vm.activeNavIdx = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('div', {
    staticClass: "page-cover"
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "router-fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-27183daa","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/page/common/Main.vue
// module id = 748
// module chunks = 1